import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-knowledge-base-table',
  templateUrl: './knowledge-base-table.component.html',
  styleUrls: ['./knowledge-base-table.component.scss']
})
export class KnowledgeBaseTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
